import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'ps-design';
import './MatchReviewErrorModal.scss';

class MatchReviewErrorModal extends Component {
  static propTypes = {
    tryAgain: PropTypes.func.isRequired,
    openReport: PropTypes.func.isRequired,
    onClickClose: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { showing: false };
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  show() {
    if (this.state.showing) return;

    this.modal.show();
    this.setState({ showing: true });
  }

  hide() {
    if (!this.state.showing) return;

    this.modal.hide();
    this.setState({ showing: false });
  }

  render() {
    return (
      <Modal
        className="pcenter-match-review-load-error"
        displayCloseButton={false}
        allowClose={false}
        ref={m => {
          this.modal = m;
        }}
      >
        <div className="pcenter-match-review-load-error__content">
          <i className="icon-cancel pcenter-match-review-load-error__close" onClick={this.props.onClickClose} />
          <h3 className="pcenter-match-review-load-error__title">
            <span className="pcenter-match-review-load-error__icon icon-reverse icon-circle">
              <i className="icon-attention-alt" />
            </span>
            There's an error that occurred when reviewing matches.
          </h3>
          <p className="pcenter-match-review-load-error__details">
            The system is trying to find duplicate matches and zero weighted matches before generating reports.
          </p>
          <p className="pcenter-match-review-load-error__instructions">
            Please&nbsp;
            <a onClick={this.props.tryAgain}>try again</a>
            &nbsp;or&nbsp;
            <a onClick={this.props.openReport}>include all matches & generate reports</a>
          </p>
        </div>
      </Modal>
    );
  }
}

export default MatchReviewErrorModal;
